const baseDate = new Date(2026, 1, 1);

const atHour = (hour, minute = 0) =>
  new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    hour,
    minute,
    0,
    0
  );

export const reservationsMock = [
  {
    id: 1345,
    reservationNumber: "1345",
    tableLabel: "16 C",
    guests: 8,
    status: "confirmed",
    startTime: atHour(13, 5),
    endTime: atHour(13, 35),
  },
  {
    id: 1346,
    reservationNumber: "1346",
    tableLabel: "16 C",
    guests: 6,
    status: "pending",
    startTime: atHour(15, 5),
    endTime: atHour(15, 35),
  },
  {
    id: 1347,
    reservationNumber: "1347",
    tableLabel: "16 C",
    guests: 4,
    status: "confirmed",
    startTime: atHour(17, 5),
    endTime: atHour(17, 35),
  },
  {
    id: 1348,
    reservationNumber: "1348",
    tableLabel: "16 C",
    guests: 10,
    status: "arrived",
    startTime: atHour(17, 10),
    endTime: atHour(17, 35),
  },
  {
    id: 1349,
    reservationNumber: "1349",
    tableLabel: "16 C",
    guests: 12,
    status: "pending",
    startTime: atHour(17, 15),
    endTime: atHour(17, 35),
  },
];

export const toScheduleEvents = (reservations) =>
  reservations.map((reservation) => ({
    Id: reservation.id,
    Subject: `حجز رقم #${reservation.reservationNumber}`,
    StartTime: reservation.startTime,
    EndTime: reservation.endTime,
    reservationNumber: reservation.reservationNumber,
    tableLabel: reservation.tableLabel,
    guests: reservation.guests,
    status: reservation.status,
  }));

